// src/components/common/TabButtonGroup.tsx
import styled from 'styled-components'

import { Nanum_eb_size, Nanum_rb_size } from '@/styles/font/NanumSquare'
import { mediaMobile, mediaTablet } from '@/styles/mediaQuery'

interface TabButtonGroupProps {
  tabs: string[]
  activeIndex: number
  onChange: (index: number) => void
  className?: string
}

const TabButtonGroup = ({ tabs, activeIndex, onChange, className }: TabButtonGroupProps) => {
  return (
    <TabButtonWrap className={className}>
      {tabs.map((label, idx) => (
        <TabButton
          key={idx}
          onClick={() => onChange(idx)}
          $isActive={activeIndex === idx}
          className={className}
        >
          {label}
        </TabButton>
      ))}
    </TabButtonWrap>
  )
}

export default TabButtonGroup

const TabButtonWrap = styled.div`
  display: flex;
  gap: 34px;
  justify-content: space-between;

  ${mediaTablet} {
    gap: 4px;
  }

  &.home-tab {
    margin: 35px 0 45px;
    gap: 22px;
    justify-content: center;

    ${mediaTablet} {
      gap: 54px;
      margin: 24px 0 12px;
      padding-left: 27px;
      padding-right: 27px;
    }

    ${mediaMobile} {
      gap: 2px;
      padding-left: 0px;
      padding-right: 0px;
    }
  }

  &.support-tab {
    ${mediaTablet} {
      margin-left: 18%;
      margin-right: 18%;
    }

    ${mediaMobile} {
      white-space: pre-line;
      margin-left: 24px;
      margin-right: 24px;
    }
  }

  &.faq-tab {
    gap: 0;
  }
`

export const TabButton = styled.button<{ $isActive?: boolean }>`
  flex: 1;
  ${Nanum_rb_size(20)}
  background-color: var(--gray-ef);
  border-radius: 10px;
  color: ${({ $isActive }) => ($isActive ? 'var(--white)' : 'var(--gray-64)')};
  background-color: ${({ $isActive }) => ($isActive ? 'var(--black)' : ' var(--gray-ef);')};
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  padding: 19px 21px;

  ${mediaTablet} {
    ${Nanum_rb_size(14)};
    padding: 14px 0;
    border-radius: 6px;
    border-width: 2px;
  }

  ${mediaMobile} {
    ${Nanum_rb_size(12)};
  }

  &.home-tab {
    max-width: 370px;
    ${Nanum_eb_size(22)};
    letter-spacing: -1px;
    border-radius: 37px;
    background-color: var(--gray-fb);

    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
    color: var(--black);
    box-shadow: ${({ $isActive }) => ($isActive ? '0 2px 8px 0 rgba(0, 0, 0, 0.2)' : 'none')};

    ${mediaTablet} {
      padding: 9px 0;
      background-color: var(--white);
      max-width: 280px;
      ${Nanum_eb_size(14)};
      width: 100%;
    }

    ${mediaMobile} {
      width: 100%;
    }
  }

  &.faq-tab {
    border-radius: 0;
    color: ${({ $isActive }) => ($isActive ? 'var(--black)' : 'var(--gray-64)')};
    background-color: white;
    border-bottom: 4px solid ${({ $isActive }) => ($isActive ? 'var(--black)' : 'var(--gray-ef)')};
    margin-top: 75px;

    ${mediaTablet} {
      margin-top: 55px;
    }
  }

  &.support-tab {
    border-radius: 10px;
    ${mediaMobile} {
      padding: 8px 0;
    }
  }
`
